// src/navigation/navigationTracker.ts

let navigationStackCount = 0;

/**
 * Call this on every route change
 */
export const markNavigation = () => {
  navigationStackCount += 1;
};

/**
 * Determines if we can safely go back
 */
export const canGoBack = (): boolean => {
  return navigationStackCount > 1;
};

/**
 * Optional: Reset tracker (useful for logout or app reset)
 */
export const resetNavigation = () => {
  navigationStackCount = 0;
};
